import { render, staticRenderFns } from "./RecordEdit.vue?vue&type=template&id=7d822ab4"
import script from "./RecordEdit.js?vue&type=script&lang=js&external"
export * from "./RecordEdit.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports